import React, {memo} from "react";
import {css} from "@emotion/react";

import {ph, w100} from "@pg-design/helpers-css";
import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTileList} from "../../../../property_list/PropertyListTileList";
import {IOfferDetail} from "../../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    setFilterValues: (filterValues: ISearchFiltersFormValues) => void;
    gtmMeta: {
        listName: string;
        listId: string;
    };
}

export const propertyListTilesFilterFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox,
    construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTiles: React.FC<IProps> = memo((props) => {
    const {pageCount, onPageChange, page, filterRequestState, properties} = props.propertyListObj;
    const {isMobile} = useUserDevice();

    const handlePageChange = (value: number) => {
        const filterQueryValues = toQueryValues(propertyListTilesFilterFields, props.filterValues);
        onPageChange(value, filterQueryValues, true);
    };

    return (
        <>
            <PropertyListTileList
                requestState={filterRequestState}
                properties={properties}
                offer={props.offer}
                css={propertyListWrapper}
                gtmMeta={props.gtmMeta}
            />

            {pageCount > 0 && (
                <Pagination
                    currentPage={page.currentPage}
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});

const propertyListWrapper = css`
    padding-left: 0 !important;
    padding-right: 0 !important;

    > ul {
        ${ph(0)};
        ${w100};
    }
`;
import React, {memo} from "react";
import {css} from "@emotion/react";

import {ph, w100} from "@pg-design/helpers-css";
import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FormFieldType, toQueryValues} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IPropertyListObj} from "../../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../../property_list/PropertyListFilters";
import {PropertyListTileList} from "../../../../property_list/PropertyListTileList";
import {IOfferDetail} from "../../../types/IOfferDetail";

interface IProps {
    offer: IOfferDetail;
    propertyListObj: IPropertyListObj;
    filterValues: ISearchFiltersFormValues;
    setFilterValues: (filterValues: ISearchFiltersFormValues) => void;
    gtmMeta: {
        listName: string;
        listId: string;
    };
}

export const propertyListTilesFilterFields = {
    area: FormFieldType.InputRange,
    rooms: FormFieldType.SelectRangeNumber,
    price: FormFieldType.InputRange,
    floor_choices: FormFieldType.MultiCheckbox,
    house_storeys: FormFieldType.MultiCheckbox,
    construction_end_date: FormFieldType.Checkbox
};

export const OfferDetailPropertyListTiles: React.FC<IProps> = memo((props) => {
    const {pageCount, onPageChange, page, filterRequestState, properties} = props.propertyListObj;
    const {isMobile} = useUserDevice();

    const handlePageChange = (value: number) => {
        const filterQueryValues = toQueryValues(propertyListTilesFilterFields, props.filterValues);
        onPageChange(value, filterQueryValues, true);
    };

    return (
        <>
            <PropertyListTileList
                requestState={filterRequestState}
                properties={properties}
                offer={props.offer}
                css={propertyListWrapper}
                gtmMeta={props.gtmMeta}
            />

            {pageCount > 0 && (
                <Pagination
                    currentPage={page.currentPage}
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                    size={isMobile ? PaginationSize.SM : PaginationSize.MD}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </>
    );
});

const propertyListWrapper = css`
    padding-left: 0 !important;
    padding-right: 0 !important;

    > ul {
        ${ph(0)};
        ${w100};
    }
`;
